import {EventWrapper, GameEventWrapper, RegularEventWrapper} from "@/app/pwa/(main-layout)/events/lib/types";

export function isGameEventWrapper(event: EventWrapper): event is GameEventWrapper {
  return event.type === "game"
}

export function isRegularEventWrapper(event: EventWrapper): event is RegularEventWrapper {
  return event.type === "event"
}

export function eventTitle(event: EventWrapper) {
  if (isGameEventWrapper(event)) {
    return `${event.match.ATeam?.Name} - ${event.match.BTeam?.Name}`
  } else {
    return event.event.title
  }
}
